import React, { Suspense, useContext, useEffect, useState } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
// import Login from "./components/login/Login";
// import DefaultLayout from "./layout/DefaultLayout";
import "./common/common_css/Common_Css.css";
import "./common/common_css/Form_Css.css";
import { Spinner } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { AuthLogOut, GETAuthLogin } from "./features/auth/Slice";
import { Context } from "./utils/context";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./components/login/Login"));
const Page404 = React.lazy(() => import("./components/page404/Page404"));
const Page500 = React.lazy(() => import("./components/page500/Page500"));

function App({}) {
  const { isSidebarOpen, isAllow, signin } = useContext(Context);
  return (
    <Suspense
      fallback={
        <div className="pt-3 text-center">
          <Spinner
            animation="grow"
            variant="primary"
            style={{
              width: "4rem",
              height: "4rem",
              color: "#fbca06",
              background: "#fbca06",
            }}
          />
        </div>
      }
    >
      {!signin ? (
        <Login />
      ) : (
        <Routes>
          <Route exact path="/" name="Login Page" element={<Login />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </Routes>
      )}
    </Suspense>
  );
}

export default App;
